/**
 * Fingerprint API prototype
 * @param scope - shop number
 * @param {FingerprintService} ServiceClient - Fingerprint Service router for CRUD operations
 * @param {UAParser} UAParser - User Agent parser
 * @returns {Fingerprint}
 * @constructor
 */
window.Fingerprint = function (scope, ServiceClient, UAParser) {
  var _this = this;

  /**
   *
   * @type {{IOS_APP_OPENED: string, ANDROID_APP_OPENED: string}}
   */
  var EVENT_NAMES = {
    IOS_APP_OPENED: 'iosAppOpened',
    ANDROID_APP_OPENED: 'androidAppOpened'
  };

  /**
   * Fingerprint Id.
   */

  var fingerprintId;
  /**
   * Fingerprint parts (things considered in matching operation).
   *
   * @type {{ip: null, os: null, scope: null, screen: null}}
   */
  var fingerprintParts = {
    ip: null,
    os: null,
    scope: null,
    screen: null
  };

  /**
   * Fingerprint data storage. When changed, must be synchronized with
   * service.
   *
   * @type {{}}
   */
  var fingerprintData = {};

  /**
   * Returns fingerprintId
   *
   * @return {string|undefined}
   */
  _this.getId = function () {
    return fingerprintId;
  };

  /**
   * Returns copy of fingerprintParts
   * local variable.
   *
   * @returns {object}
   */
  _this.getParts = function () {
    return $.extend(true, {}, fingerprintParts);
  };

  /**
   * Updates fingerprintPart with new value,
   * and synchronises with the server.
   *
   * @param {string} name
   * @param {string} value
   */
  _this.setPart = function (name, value) {
    _validatePart(name, value);
    fingerprintParts[name] = value;
    _push();
  };

  /**
   * Returns copy of fingerprintData
   * local variable.
   *
   * @return {object}
   */
  _this.getData = function () {
    return $.extend(true, {}, fingerprintData);
  };

  /**
   * Sets data property and synchronise with server.
   * @param {string} name
   * @param {string|object|number} value
   */
  _this.setData = function (data, onSuccess, onError) {
    if (typeof data === 'object') {
      $.extend(fingerprintData, data);
    } else {
      console.warn('Fingerprint.setData: Invalid input. Data must be and object.');
      return;
    }

    _push(onSuccess, onError);
  };

  /**
   * Sets data with app opened timestamp
   */
  _this.updateAppOpenedTimestamp = function () {
    var eventName = _getAppOpenedEventName();
    var data = {};
    data[eventName] = Date.now();
    _this.setData(data);
  };

  /**
   * Returns timestamp of last registered app open event
   * for current fingerprint.
   *
   * Detect environment (android/ios) automatically, but
   * you can provide one explicitly.
   *
   * @returns {*}
   */
  _this.getAppOpenedTimestamp = function () {
    var eventName = _getAppOpenedEventName();
    var data = _this.getData();

    if (data.hasOwnProperty(eventName)) {
      return data[eventName];
    }

    return null;
  };

  /**
   * Inits fingerprint with provided
   * fingerprintId
   *
   * @param {string} id
   * @param {function} onSuccess
   * @param {function} onError
   */
  _this.init = function (id, onSuccess, onError) {
    if (!id) {
      throw new Error('No id given for Fingerprint.init');
    }

    fingerprintId = id;
    _pull(onSuccess, onError);
  };

  /**
   * Pulls fresh Fingerprint data
   * from ServiceClient.
   *
   * @param {function} onSuccess
   * @param {function} onError
   */
  _this.pull = function (onSuccess, onError) {
    if (!fingerprintId) {
      console.warn('Cannot pull. FingerprintId is not set.');
    }

    _pull(onSuccess, onError);
  };

  /**
   * Sends request to server for new Fingerprint.
   * Synchronises with current object on success.
   *
   * @param {function} onSuccess
   * @param {function} onError
   */
  _this.create = function (onSuccess, onError) {
    onError = _castToFunction(onError);
    onSuccess = _castToFunction(onSuccess);

    var data = _fetchParts();

    ServiceClient.create(
      data,
      function (incomingData) {
        _updateProperties(incomingData.Fingerprint);
        onSuccess(incomingData);
      },

      function (msg) {
        onError(msg);
      }
    );
  };

  /**
   * Send a request to server to find a Fingerprint
   * with automatically obtained fingerprint parts.
   *
   * @param {function} onSuccess
   * @param {function} onError
   */
  _this.find = function (onSuccess, onError) {
    onSuccess = _castToFunction(onSuccess);
    onError = _castToFunction(onError);

    var fingerprintParts = _fetchParts();

    ServiceClient.find(
      fingerprintParts,
      function (incomingData) {

        _updateProperties(incomingData.Fingerprint);
        onSuccess(incomingData);
      },

      function (message) {

        onError(message);
      }
    );
  };

  /**
   * Read and format possible fingerprint parts from
   * environment.
   *
   * @returns {{os: {string}, screen: {string}, scope: {string}}}
   * @private
   */
  function _fetchParts() {
    var parts = {
      os: _getOS(),
      screen: _getScreen(),
      scope: _getScope()
    };

    return parts;
  }

  /**
   * Forces variable to be function.
   * @param {mixed} f
   * @returns {Function}
   * @private
   */
  function _castToFunction(f) {
    return typeof f === 'function' ? f : function () {
    };
  }

  /**
   * Checks and returns provided scope
   * @returns {string}
   * @private
   */
  function _getScope() {
    if (typeof scope === 'string') {
      return scope;
    } else {
      return 'scope-not-available';
    }
  }

  /**
   * Gets screen size as formatted string.
   * @returns {string}
   * @private
   */
  function _getScreen() {
    var originalWidth = window.screen.width;
    var originalHeight = window.screen.height;

    var width = window.screen.width;
    var height = window.screen.height;

    /*
     * swap values of it device changes width and heigh depending on orientation
     */
    if (width > height) {
      height = originalWidth;
      width = originalHeight;
    }

    return width + 'x' + height;
  }

  /**
   * Gets OS version as formatted string
   * @returns {string}
   * @private
   */
  function _getOS() {
    return UAParser.getOS().name + ' ' + UAParser.getOS().version;
  }

  /**
   * Returns name for of appOpened event for current OS.
   * @returns {string}
   * @private
   */
  function _getAppOpenedEventName() {
    return _isAndroid() ? EVENT_NAMES.ANDROID_APP_OPENED : EVENT_NAMES.IOS_APP_OPENED;
  }

  /**
   * Checks if current os is Android.
   *
   * @returns {boolean}
   * @private
   */
  function _isAndroid() {
    return UAParser.getOS().name.toLowerCase() === 'android';
  }

  /**
   * Asks the server for Fingerprint and updates
   * local properties on success.
   *
   * @param {function} onSuccess
   * @param {function} onError
   * @private
   */
  function _pull(onSuccess, onError) {

    if (!fingerprintId) {
      throw new Error('Trying to pull Fingerprint without fingerprintId');
    }

    ServiceClient.get(
      fingerprintId,

      function (incomingData) {
        _updateProperties(incomingData.Fingerprint);

        if (typeof onSuccess === 'function') {
          onSuccess(incomingData);
        }
      },

      function (err) {
        if (typeof onError === 'function') {
          onError(err);
        }
      }
    );
  }

  /**
   * Sends an update to server with local properties.
   * @private
   */
  function _push(onSuccess, onError) {
    ServiceClient.update(_this.getId(), fingerprintParts, fingerprintData, onSuccess, onError);
  }

  /**
   * Validates fingerprint part value.
   *
   * @param {string} name
   * @param {string} value
   * @private
   * @throws {Error}
   */
  function _validatePart(name, value) {
    if (typeof name !== 'string' || typeof value !== 'string' || !name || !value) {
      throw new Error('Part invalid, name: ' + name + ', value: ' + value);
    }
  }

  /**
   * Parses incoming data from server and updates
   * local properties according to given one.
   *
   * @param {object} incomingData
   * @returns {boolean}
   * @private
   */
  function _updateProperties(incomingData) {
    var partsKeys = ['ip', 'os', 'scope', 'screen'];
    var key;
    var partName;

    if (incomingData.hasOwnProperty('id') && fingerprintId !== incomingData.id) {
      fingerprintId = incomingData.id;
    }

    for (key in partsKeys) {
      partName = partsKeys[key];
      if (incomingData.hasOwnProperty(partName) && incomingData[partName]) {
        fingerprintParts[partName] = incomingData[partName];
      }
    }

    if ($.isArray(incomingData.data)) {
      incomingData.data = {};
    }

    if (incomingData.hasOwnProperty('data') && typeof incomingData.data === 'object') {
      fingerprintData = incomingData.data;
    } else if (!$.isEmptyObject(incomingData)) {
      fingerprintData = {};
    }

  }

  function _init() {
    if (typeof scope !== 'string') {
      console.warn('Fingerint scope not provided.');
    }
  }

  _init();

  return _this;
};



// WEBPACK FOOTER //
// ./Library/1.0/common/Fingerprint/Fingerprint.js